// METRO brand customizations - global delegated event listeners

// Tracks the user's chosen size-gender view per <variant-picker> instance so
// it survives Shopify's DOM morph on variant changes (color swap, etc), which
// re-renders the fieldset from the server and would otherwise wipe both the
// active toggle state and the displayed size text.
const metroSizePreference = new WeakMap();

function metroApplyGenderState(fieldset, gender) {
  const legend = fieldset.querySelector('legend');
  const buttons = legend ? legend.querySelectorAll('.metro-size-toggle__btn') : null;
  if (buttons) {
    buttons.forEach((btn) => {
      btn.classList.toggle('is-active', btn.dataset.gender === gender);
    });
  }

  fieldset.querySelectorAll('[data-mens-size]').forEach((label) => {
    const textSpan = label.querySelector('[data-key="variant-option-text"]');
    if (!textSpan) return;
    const size = gender === 'womens' ? label.dataset.womensSize : label.dataset.mensSize;
    textSpan.textContent = size;
  });
}

document.addEventListener('click', (event) => {
  const toggleBtn = event.target.closest('.metro-size-toggle__btn');
  if (!toggleBtn) return;

  const fieldset = toggleBtn.closest('fieldset');
  const picker = fieldset ? fieldset.closest('variant-picker') : null;
  if (!fieldset) return;

  const gender = toggleBtn.dataset.gender;
  if (picker) metroSizePreference.set(picker, gender);
  metroApplyGenderState(fieldset, gender);
});

// Re-apply the chosen (or product-default) gender view whenever Horizon morphs
// the variant picker (color swaps, combined-listing navigation, etc). Falls
// back to each fieldset's own data-default-gender (set server-side in Liquid:
// women's for products titled "(Women's)", otherwise men's) until the shopper
// explicitly clicks the toggle. Guarded with a flag so our own DOM writes (textContent/classList)
// don't re-trigger themselves.
function metroObserveVariantPicker(picker) {
  if (picker.dataset.metroObserved) return;
  picker.dataset.metroObserved = 'true';

  let applying = false;

  const observer = new MutationObserver(() => {
    if (applying) return;
    applying = true;

    picker.querySelectorAll('fieldset').forEach((fieldset) => {
      const toggle = fieldset.querySelector('.metro-size-toggle');
      if (!toggle) return;
      const gender = metroSizePreference.get(picker) || toggle.dataset.defaultGender || 'mens';
      metroApplyGenderState(fieldset, gender);
    });

    queueMicrotask(() => {
      applying = false;
    });
  });

  observer.observe(picker, { childList: true, subtree: true, attributes: true, characterData: true });
}

function metroInitVariantPickers(root = document) {
  root.querySelectorAll('variant-picker').forEach((picker) => metroObserveVariantPicker(picker));
}

document.addEventListener('DOMContentLoaded', () => metroInitVariantPickers());
document.addEventListener('shopify:section:load', () => metroInitVariantPickers());
